// GENERAL PERMISSIONS
export const MANAGER = 1
export const BRANCH_MANAGER = 2
export const SALESPERSON = 3
export const ACTIVITY_FOLLOW_UP_NONE = 4
export const ALL_BRANCH = 5
export const CREDIT_UNDERWRITER = 6
export const DELETE_TASK = 7
export const DELETE_REFERRAL = 8
export const DIRECT_MAIL_ACTIVITIES = 9
export const ENABLE_EXECUTIVE = 10
export const EDIT_PHONE_NUMBER = 11
export const HELP_SUPPORT = 12
export const INCOMING_CALL = 13
export const IS_EXECUTIVE = 14
export const OUTSIDE_SALES = 15
export const PBX_COMPASS = 16
export const RECEIVE_CREDIT_APP = 17
export const SUBMIT_TO_LEGAL = 18
export const VIEW_ALL_ACCOUNTS = 19
export const VIEW_ALL_DIVISION_ACCOUNTS = 20
export const VIEW_ALL_LEADS = 21
export const VIEW_ALL_MY_TEAM_ONLY = 22
export const LEADS_PROSPECTS = 23
export const VIEW_MY_TEAM_ONLY_ACCOUNTS = 24
export const DELETE_ACTIVITY = 42
export const DELETE_CONTACT = 43
export const VIEW_ACCOUNTS_INSIGHTS = 44
export const CAN_UPLOAD_NEW_LEADS = 46
export const CHANGE_CONTACT_STATUS = 47
export const CHANGE_USER_PASSWORD = 48
export const ASSISTANT = 50
export const RETENTION = 51

// TRUCK SALES PERMISSIONS
export const CAN_ADD_INVENTORY = 25
export const CAN_EDIT_INVENTORY = 26
export const DO_NOT_ALLOW_TO_CREATE_QUOTES = 27
export const DO_NOT_ALLOW_TO_ADD_DOCUMENTS = 28
export const DO_NOT_ALLOW_TO_CREATE_GET_READY_FORMS = 29
export const SEE_WHOLESALE_INVENTORY = 30
export const TRUCK_SALES_FINANCIAL = 31
export const VIEW_ALL_QUOTES = 32
export const CAN_LOGIN_TO_TRUCK_SALES = 45
export const TRUCK_SALES_INVENTORY_ADDITIONAL_DATA = 52
export const CAN_EDIT_INVENTORY_VIN = 53
export const CREATE_QUOTE_WITH_IN_TRANSIT_INVENTORY = 54
export const VIEW_BLACKLISTED_PHONES = 59
export const EDIT_SOLD_INVENTORIES_PERMISSION = 61
export const MASS_SMS = 63

// INSURANCE PERMISSIONS
export const INS_GROSS_RECEIP = 33
export const INSURANCE_SPECIALIST = 34
export const INSURANCE_UNDERWRITER = 35
export const ITA_MANAGER = 36
export const ITA_USER = 37
export const REMOVE_DRIVER = 38
export const SEE_DRIVER = 39

// CPS PERMISSIONS
export const VIEW_ALL_MERCHANTS = 40

// CEF PERMISSIONS
export const RECEIVE_LOAN_CLOSE_REQUEST = 41
export const CAN_UPLOAD_NEW_DEALERS = 49
